import { useState, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { api } from '../../../config';
import { getAuthToken } from '../../../auth/tokenvalidation';

const useClosingEvaluationStatus = () => {
  const [isLoading, setIsLoading] = useState(false);

  const closeEvaluation = useCallback(async ({ procurementId, onSuccess }) => {
    if (!procurementId) {
      toast.error('Procurement ID is required.');
      return false;
    }

    const token = getAuthToken();
    if (!token) {
      toast.error('Authentication required. Please login again.');
      return false;
    }

    setIsLoading(true);
    try {
      await axios.post(
        `${api.API_URL}/procurement/ClosingEvaluationStatus`,
        { procurementId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success('Evaluation locked successfully.');
      onSuccess?.();
      return true;
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        'Failed to lock evaluation.';
      toast.error(message);
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { closeEvaluation, isLoading };
};

export default useClosingEvaluationStatus;
